module.exports = __webpack_public_path__ + "img/peerspectives-bg.34829a76.png";